import Paging from './Paging';
import { calculateRange, calcCurrentPage } from './utils';

export { Paging, calculateRange, calcCurrentPage };
try {
    // @ts-ignore
    calculateRange.displayName = "calculateRange";
    // @ts-ignore
    calculateRange.__docgenInfo = { "description": "", "displayName": "calculateRange", "props": {} };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/shared/components/Paging/index.ts#calculateRange"] = { docgenInfo: calculateRange.__docgenInfo, name: "calculateRange", path: "src/shared/components/Paging/index.ts#calculateRange" };
}
catch (__react_docgen_typescript_loader_error) { }